"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideableComponents = void 0;
var AddressField_1 = require("./AddressField");
var ButtonGroup_1 = require("./ButtonGroup");
var ErrorSection_1 = require("./ErrorSection");
var InternalLink_1 = require("./InternalLink");
var PageLayout_1 = require("./PageLayout");
var Pii_1 = require("./Pii");
var Redirect_1 = require("./Redirect");
var SummaryCard_1 = require("./SummaryCard");
var TextLink_1 = require("./TextLink");
var TransactionTitle_1 = require("./TransactionTitle");
var overrideableComponents = {
    ButtonGroup: ButtonGroup_1.ButtonGroup,
    TextLink: TextLink_1.TextLink,
    InternalLink: InternalLink_1.InternalLink,
    ErrorSection: ErrorSection_1.ErrorSection,
    Redirect: Redirect_1.Redirect,
    Pii: Pii_1.Pii,
    TransactionTitle: TransactionTitle_1.TransactionTitle,
    SummaryCard: SummaryCard_1.SummaryCard,
    AddressField: AddressField_1.AddressField,
    PageLayout: PageLayout_1.PageLayout,
};
exports.overrideableComponents = overrideableComponents;
